import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { beforeItems, afterItems } from "../data/content";
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-43" data-mp="3ofhx3ds4fjys">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="3sgl8no34ytu7">
        <SectionHeading eyebrow="The clinical workflow transformation" title="From scattered references to a structured approach" subtitle="See the difference a structured system makes in your insulin resistance nutrition care." data-id="element-45" data-mp="3sjfw7ohg4uru" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-46" data-mp="34t3ddiknxdmh">
          <div className="rounded-2xl border-2 border-danger/25 bg-danger-soft p-5 sm:p-7" data-id="element-47" data-mp="39qbxvpta9tqw">
            <div className="flex items-center gap-3" data-id="element-48" data-mp="2vrcccr12huyy">
              <span className="rounded-lg bg-danger px-3 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-49" data-mp="2vrvsc275q9ac">Before</span>
            </div>
            <p className="mt-4 font-serif text-xl font-bold text-ink" data-id="element-50" data-mp="x40us94bck4x">You may recognize some of these situations:</p>
            <ul className="mt-5 space-y-4" data-id="element-51" data-mp="t1x78m4ddp3a">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-relaxed text-ink" data-id="element-52" data-mp="172zuv3b0j7gb">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger text-white" data-id="element-53" data-mp="123deikzw1b3a">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-54" data-mp="eelyst3hil7e" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-cta/30 bg-success-soft p-5 sm:p-7" data-id="element-55" data-mp="o56ry10e2xix">
            <div className="flex items-center gap-3" data-id="element-56" data-mp="jbkpt2ruqc1d">
              <span className="rounded-lg bg-cta px-3 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-57" data-mp="3rsp676cicb49">After</span>
            </div>
            <p className="mt-4 font-serif text-xl font-bold text-ink" data-id="element-58" data-mp="3mtckwq1abc3s">
              With Insulin Resistance Nutrition Blueprint™, you'll have a structured system to:
            </p>
            <ul className="mt-5 space-y-4" data-id="element-59" data-mp="1voj6tv3ohogq">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-relaxed text-ink" data-id="element-60" data-mp="20hlqnbinljjq">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-61" data-mp="24h2y2ahn4qrj">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-62" data-mp="17tpx2fods7r6" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-63" data-mp="1guwhgzu5i2pp">
          <p className="text-[17px] text-muted sm:text-lg" data-id="element-64" data-mp="1lsfszrzgs1dy">The goal isn't to replace your clinical judgment.</p>
          <p className="mt-2 font-serif text-2xl font-bold text-navy sm:text-3xl" data-id="element-65" data-mp="2s7740oiax2lp">
            It's to give your existing knowledge a clearer structure.
          </p>
        </div>

        <div className="mt-10" data-id="element-66" data-mp="379f6bwdnpdmb">
          <CTAButton label="I want a more structured clinical workflow" note="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-67" data-mp="37culez7bymnq" />
        </div>
      </div>
    </section>;
}